import PropTypes from 'prop-types'

export const optionShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number
})

export const fundingShape = PropTypes.shape({
  label: PropTypes.string,
  description: PropTypes.string,
  bring: PropTypes.number,
  maxStep: PropTypes.number,
  minStep: PropTypes.number,
  step: PropTypes.number,
  monthly: PropTypes.number,
  price: PropTypes.number
})

const imageVehicleShape = PropTypes.shape({
  src: PropTypes.string,
  w: PropTypes.number,
  h: PropTypes.number
})

export const vehicleShape = PropTypes.shape({
  id: PropTypes.number,
  typeVehicle: PropTypes.number,
  price: PropTypes.number,
  urlImage: PropTypes.string,
  images: PropTypes.arrayOf(imageVehicleShape),
  dateOfRegistration: PropTypes.string,
  brand: PropTypes.string,
  registrationPlate: PropTypes.string,
  model: PropTypes.string,
  finishes: PropTypes.string,
  energy: PropTypes.string,
  options: PropTypes.arrayOf(optionShape),
  body: PropTypes.string,
  power: PropTypes.number,
  taxPower: PropTypes.number,
  kilowatt: PropTypes.any,
  gearBoxType: PropTypes.string,
  doors: PropTypes.number,
  mileage: PropTypes.number,
  trailerHitch: PropTypes.number,
  CV: PropTypes.number,
  CH: PropTypes.number,
  seating: PropTypes.number,
  transmission: PropTypes.string,
  NumberOfReports: PropTypes.number,
  CO2: PropTypes.number,
  color: PropTypes.string,
  warranty: PropTypes.string,
  reference: PropTypes.string,
  typeOfEngine: PropTypes.string,
  cylinder: PropTypes.number,
  maxSpeed: PropTypes.number,
  acceleration: PropTypes.number,
  consumption: PropTypes.shape({
    urban: PropTypes.number,
    extraUrban: PropTypes.number,
    mixed: PropTypes.number
  }),
  dimensions: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    length: PropTypes.number,
    wheelbase: PropTypes.number
  }),
  weight: PropTypes.shape({
    total: PropTypes.number,
    unloaded: PropTypes.number
  }),
  tires: PropTypes.shape({
    front: PropTypes.string,
    back: PropTypes.string
  }),
  trunk: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number
  }),
  load: PropTypes.shape({
    payload: PropTypes.number,
    roof: PropTypes.number
  }),
  funding: fundingShape
})

const brandShape = PropTypes.shape({
  id: PropTypes.string,
  wording: PropTypes.string
})

const modelShape = PropTypes.shape({
  id: PropTypes.string,
  wording: PropTypes.string
})

const bodyShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number
})

const energyShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number
})

const gearboxShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number
})

const doorShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number
})

const priceShape = PropTypes.shape({
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number
})

const mileageShape = PropTypes.shape({
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number
})

const typeShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number
})
const yearShape = PropTypes.shape({
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number
})

const chShape = PropTypes.shape({
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number
})

const seatShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number
})

const ecologyShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number
})

const tractionShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.number
})

const colorShape = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string
})

const filtersListShape = PropTypes.shape({
  brandsList: PropTypes.arrayOf(brandShape),
  modelsList: PropTypes.arrayOf(modelShape),
  bodiesList: PropTypes.arrayOf(bodyShape),
  energiesList: PropTypes.arrayOf(energyShape),
  gearboxesLists: PropTypes.arrayOf(gearboxShape),
  doorsList: PropTypes.arrayOf(doorShape),
  pricesList: priceShape,
  mileagesList: mileageShape,
  typesList: PropTypes.arrayOf(typeShape),
  yearsList: yearShape,
  chsList: chShape,
  seatsList: PropTypes.arrayOf(seatShape),
  ecologiesList: PropTypes.arrayOf(ecologyShape),
  tractionsList: PropTypes.arrayOf(tractionShape),
  colorsList: PropTypes.arrayOf(colorShape)
})

export const stockShape = PropTypes.shape({
  vehiclesList: PropTypes.arrayOf(vehicleShape),
  filtersList: filtersListShape
})
